import {IPpPlanningWizardSelectionGridData} from '../pp-planning-wizard.types';
import {
  IFieldScanDataStatsTableItem
}                                           from '../../../ap-n-fertilization-entry-components/types/field-scan-data-table-stats.types';
import {
  FieldScanDataTableStatisticService
}                                           from '../../../ap-n-fertilization-entry-components/services/field-scan-data-table-statistic.service';
import {Injectable}                         from '@angular/core';
import {StatisticService}                   from '../../../../services/data/statistic.service';

@Injectable({providedIn: 'root'})
export class PpPlanningWizardSelectionService {
  constructor(private statisticService: StatisticService,
              private fieldScanDataTableStatisticService: FieldScanDataTableStatisticService) {
  }

  /**
   * Extracts the first EPPO code from the selected fields
   * Used for determining the crop type when multiple fields are selected
   * @param data Array of selected field data
   * @returns The first valid EPPO code found in the selected fields, or undefined if no EPPO codes are present
   * @public
   */
  public getEppoCodeFromSelectedFields(data: IPpPlanningWizardSelectionGridData[]): string | undefined {
    const eppoCodes = data.filter(x => !!x.EppoCode)
      .map(x => x.EppoCode);
    if (eppoCodes.length === 0) {
      return undefined;
    }
    return eppoCodes[0];
  }

  /**
   * Generates field statistics for selected or total items
   * This method:
   * - Handles cases with no selected or total items
   * - Uses all items if no items are selected
   * - Transforms grid data into statistical table items
   * - Sets statistic data in the statistic store
   * @param selectedItems Currently selected grid items
   * @param totalItems All available grid items
   */
  public generateFieldStatistic(selectedItems: IPpPlanningWizardSelectionGridData[],
                                totalItems: IPpPlanningWizardSelectionGridData[]): void {
    if (selectedItems?.length <= 0 && totalItems?.length <= 0) {
      this.fieldScanDataTableStatisticService.generateStats('', [], 'Global__latest_Sensor_reading');
      return;
    }
    if (selectedItems?.length <= 0) {
      selectedItems = totalItems;
    }
    const nStatItems: IFieldScanDataStatsTableItem[] = selectedItems.map(item => ({
      FieldName: item?.Name,
      Area: item?.Area,
      FieldNumber: item?.Nr?.toString(),
      FieldSubNumber: item?.TNr?.toString(),
      ScanDate: item?.ScanData?.Created,
      ScanNUptakeAvg: item?.ScanData?.NUptakeAvg,
      ScanNUptakeMin: item?.ScanData?.NUptakeMin,
      ScanNUptakeMax: item?.ScanData?.NUptakeMax
    }));
    const title = this.getTitleForStatistic(selectedItems, totalItems);
    this.fieldScanDataTableStatisticService.generateStats(title, nStatItems, 'Global__latest_Sensor_reading');
  }

  /**
   * Generates a title for field statistics based on selected and total items
   * This method:
   * - Transforms items into a format suitable for title generation
   * - Marks items as selected or not
   * - Uses statistic service to generate an area-based title
   * @param selectedItems Currently selected grid items
   * @param allItems All available grid items
   * @returns A generated title string for the statistics
   * @private
   */
  private getTitleForStatistic(selectedItems: IPpPlanningWizardSelectionGridData[],
                               allItems: IPpPlanningWizardSelectionGridData[]): string {
    const dataForTitles = allItems.map(x => ({
      AreaHa: x.Area,
      Selected: selectedItems.some(z => z.Id === x.Id)
    }));
    return this.statisticService.generateFieldsAreaTitle(dataForTitles);
  }
}
